module.exports = __webpack_public_path__ + "media/packs/user-cards/images/delete-a603a28905ee423f0102c775dca2599b.svg";